module.exports = __webpack_public_path__ + "assets/img/lesson_expand.0dbb48ec.png";